import {useAppDispatch, useAppSelector} from '../../redux';
import {getPrivileges} from '../../redux/actions/privilege';
import * as React from 'react';
import {Route, useNavigation} from '@react-navigation/native';
import {useEffect} from 'react';
import {Screens} from '../routing';
import {privilegesSelector} from '../../redux/selectors/privilege';

type ResolverProps = {route: Route<string>} & any;

export const PrivilegesResolver = (viewComponent: React.FC<any>) => {
  return function Resolver(props: ResolverProps) {
    const dispatch = useAppDispatch();
    const nav = useNavigation();
    const privileges = useAppSelector(privilegesSelector());

    useEffect(() => {
      if (!privileges) {
        dispatch(getPrivileges());
      }
    }, [privileges]);

    useEffect(() => {
      if (privileges && props.route.params?.ssmCode) {
        const ssmCode = props.route.params.ssmCode;
        if (privileges?.socialSupportMeasures?.find((item) => item.ssmCode === ssmCode) === undefined) {
          (nav.navigate as any)(Screens.MainTabs, {
            screen: Screens.CardServicesMenu,
            params: {screen: Screens.PrivilegesService},
          });
        }
      }
    }, []);

    // if (privileges === null) {
    //   return null;
    // }

    return React.createElement(viewComponent, props);
  };
};
